import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { async } from 'rxjs/internal/scheduler/async';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

export interface Service{
  service_title:string;
  service_image:string;
  service_description:string;
  service_overview:string;  
  service_dropdown:string;
  service_seoTitle:string;
  service_seoDes:string;
  service_iconUrl:string;
  id?: string;
}

@Component({
  selector: 'app-orderform',
  templateUrl: './orderform.component.html',
  styleUrls: ['./orderform.component.css']
})
export class OrderformComponent implements OnInit {
  serviceForm: FormGroup;
  id: any;
  servicedate: Observable<Service[]>;
  serviceDetails: any;

  constructor(private formBuilder: FormBuilder, private afs: AngularFirestore, private router: Router, private route: ActivatedRoute) {
    this.route.params.subscribe(params => {
      this.id = params['id'];
      console.log(this.id)

      if (this.id) {
        this.getSingleService(this.id).then(data => {
          data.subscribe(singleservice => {
            console.log(singleservice);
            this.serviceDetails = singleservice;
            this.serviceForm.get('pname').setValue(singleservice['service_title']);
            this.serviceForm.get('pid').setValue(this.id);
          });
        });
      }
    });
  }
  
  ngOnInit() {
    this.serviceForm = this.formBuilder.group({
      pname: ['', Validators.required],
      pid: ['', Validators.required],
      oemail: ['', Validators.required],
      omob: ['', Validators.required],
      oname: ['', Validators.required],
      oqty: ['', Validators.required],
      omgs: ['', Validators.required],
    })
  }

  
  async getSingleService(id) {
    const get = await this.afs.doc(`Service/${id}`);
    const getdata = await get.valueChanges();
    return getdata;
  }

  onSubmit(valid, value) {
    console.log(value)
    if (valid) {
        value.status = false
        value.createdAt = new Date().toString()
        this.afs.collection('orders').add(value);
        this.router.navigate(['/']);
        alert('Ordered successfully!');
    } else return false
  }

}
